import {
  createRouter,
  createWebHashHistory
} from 'vue-router'

//定义路由信息的数组
const routes = [
  //首页
  {
    path: '/index',
    name: 'Index',
    component: () => import('../views/Index.vue')
  },
  //登录页
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  //重定向
  {
    path:'/layout/:id/renter',
    redirect: '/layout/renter',
  },
  {
    path:'/layout/:id/room',
    redirect: '/layout/room',
  },
  {
    path:'/layout/:id/fee',
    redirect: '/layout/fee',
  },
  {
    path:'/layout/:id/rent',
    redirect: '/layout/rent',
  },
  {
    path:'/layout/:id/manager',
    redirect: '/layout/manager',
  },
  {
    path:'/layout/:id/money',
    redirect: '/layout/money',
  },
  {
    path:'/layout/:id/ShowData',
    redirect: '/layout/ShowData',
  },
  {
    path:'/layout/:id/notice',
    redirect: '/layout/notice',
  },
  {
    path:'/layout/:id/diary',
    redirect: '/layout/diary',
  },
  {
    path:'/layout/:id/walterElectricity',
    redirect: '/layout/walterElectricity',
  },
  {
    path:'/layout/:id/roomCategory',
    redirect: '/layout/roomCategory',
  },
  //布局页
  {
    path: '/layout',
    name: 'Layout',
    component: () => import('../views/Layout.vue'),
    //二级路由
    children: [
      {
        path: 'renter',
        name: 'Renter',
        meta: {title: '租户管理'},
        component: () => import('../views/house/Renter.vue')
      },
      {
        path: 'room',
        name: 'Room',
        meta: {title: '房间管理'},
        component: () => import('../views/house/Room.vue')
      },
      {
        path: 'fee',
        name: 'Fee',
        meta: {title: '费用设置'},
        component: () => import('../views/house/Fee.vue')
      },
      {
        path: 'walterElectricity',
        name: 'WalterElectricity',
        meta: {title: '水电管理'},
        component: () => import('../views/house/WalterElectricity.vue')
      },
      {
        path: 'rent',
        name: 'Rent',
        meta: {
          title: '租金管理'
        },
        component: () => import('../views/house/Rent.vue')
      },
      {
        path: 'manager',
        name: 'Manager',
        meta: {
          title: '人员管理'
        },
        component: () => import('../views/house/Manager.vue')
      },
      {
        path: 'money',
        name: 'Money',
        meta: {
          title: '其他收支'
        },
        component: () => import('../views/house/money.vue')
      },
      {
        path: 'showData',
        name: 'showData',
        meta: {
          title: '数据展示'
        },
        component: () => import('../views/house/ShowData.vue')
      },
      {
        path: 'notice',
        name: 'Notice',
        meta: {
          title: '通告管理'
        },
        component: () => import('../views/house/Notice.vue')
      },
      {
        path: 'diary',
        name: 'Diary',
        meta: {
          title: '日志记录'
        },
        component: () => import('../views/house/Diary.vue')
      },
      {
        path: 'roomCategory',
        name: 'RoomCategory',
        meta: {
          title: '日志记录'
        },
        component: () => import('../views/house/RoomCategory.vue')
      },
      {
        path: 'mine',
        name: 'Mine',
        meta: {
          title: '个人中心'
        },
        component: () => import('../views/manager/Mine.vue')
      },
      {
        path: 'role',
        name: 'Role',
        meta: {
          title: '角色管理'
        },
        component: () => import('../views/role/Role.vue')
      },
      {
        path: 'resetPSW',
        name: 'ResetPSW',
        meta: {
          title: '修改密码'
        },
        component: () => import('../views/manager/ResetPSW.vue')
      },
      {
        path: 'landlord',
        name: 'Landlord',
        meta: {
          title: '房东管理'
        },
        component: () => import('../views/landlord/Landlord.vue')
      },
      {
        path: '',
        name: 'Home',
        meta: {
          title: '主页'
        },
        component: () => import('../views/home/Home.vue')
      },
      {
        path: 'message',
        name: 'Message',
        meta: {
          title: '消息'
        },
        component: () => import('../views/home/Message.vue')
      },
      {
        path: 'house',
        name: 'House',
        meta: {
          title: '楼房管理'
        },
        component: () => import('../views/house/House.vue')
      }
    ]
  },
  //404页面
  {
    path: '/:pathMatch(.*)*',
    name: 'Error404',
    component: () => import('../views/Error404.vue')
  }
]

//创建一个路由器对象
const router = createRouter({
  history: createWebHashHistory(),
  routes
})

//导入 nprogress
import NProgress from 'nprogress'
//导入nprogress的样式
import 'nprogress/nprogress.css'

//定义路由导航前置守卫
router.beforeEach((to, from, next) => {
  NProgress.start();
  next()
})

//定义路由导航后置守卫
router.afterEach((to, from) => {
  NProgress.done();
})

export default router